/*
 * @Author: cc
 */
import request from "./request";
import { StorageModule } from '../modules/storage'

// 修改用户头像
export const reuqestUploadPictures = (params?: any) => {
    return request('put', `/api/system/user/_self/avatar`, params)
}
//当前用户获取个人信息
export const myself = (params?: any) => {
    return request('get', `/api/rubik/myself`, params)
}
// 修改用户头像
export const myselfAvatar = (params?: any) => {
    return request('puttext', `/api/rubik/myself/avatar`, params)
}
//当前用户修改昵称
export const nickname = (params?: any) => {
    return request('puttext', `/api/rubik/myself/nickname`, params)
}
//当前用户修改昵称
export const username = (params?: any) => {
    return request('puttext', `/api/rubik/myself/username`, params)
}
//获取文件二进制数据
export const getFile = (id?: any) => {
    return request('getblob', `/api/rubik/file/${id}/raw`,)
}
//当前用户修改密码账户
export const accountPassword = (params:any) => {
    return request('put', `/api/rubik/myself/account/password`,params)
}
//当前用户创建密码账户
export const postAccountPassword = (params:any) => {
    return request('posttxt', `/api/rubik/myself/account/password`,params)
}
//接入点查询
export const endpoint = (params?:any) => {
    return request('get', `/api/placeholder/endpoint`,params)
}
//当前用户使用手机验证创建手机账户
export const accountMmobile = (params:any) => {
    return request('post', `/api/rubik/myself/account/mobile`,params)
}

//当前用户使用手机验证创建手机账户
export const accountEmail = (params:any) => {
    return request('post', `/api/rubik/myself/account/email`,params)
}


//生成外部认证链接

export const authLink = () => {
    let url = window.location.hash.substring(2)
    console.log(url)
    StorageModule.set('bind_history_url', url)
    return request('posttxt', `/api/rubik/account/external/baidu/auth_link/bind`,
        `${process.env.REACT_APP_SCP}/#/auth_baidu`)
}

//当前用户删除指定账户

export const delAccount = (type:any,id:any,params:any) => {
    return request('delete', `/api/rubik/myself/account/${type}/${id}`,params)
}


export const hasuser = (username:any) => {
    return request('head', `/api/memo/permission/user/username/${username}`, {}, null, true)
}
//查询用户
export const getUserList = (params?:any) => {
    return request('get', `/api/memo/permission/user`, params)
}

//导入接口
export const importFileApi = (data:any) => {
    return request('put', `/api/excelling/topic/importTopic`,data)
}

export const hierarchy_view = (id?:any) => {
    return request('get', `/api/excelling/topic/${id}/hierarchy_view`,{})
}
export const setHierarchy = (id:any,data:any) => {
    return request('post', `/api/excelling/topic/${id}/hierarchy_view`,data)
}
export const taskSearch = (params?:any) => {
    return request('get', `/api/excelling/tag/memo/task/search`,params)
}

export const save_hierarchy_view = (id?:any) => {
    return request('get', `/api/excelling/topic/${id}/saveHierarchyView`,{})
}
